export default __webpack_public_path__ + "static/media/serviciosAlarma3Mobile.9387d54c.png";